export default "/images/vendor/flag-icons/flags/1x1/ga.svg?d33bfe612c008a01f156d9a3a8a83027";